import { Component, OnInit } from '@angular/core';
import { TextService } from '../../../shared/services/text.service';

@Component({
  selector: 'pa-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  textService: TextService;

  constructor(textService: TextService) {
    this.textService = textService;
    this.browserBackButtonBlocking();
  }

  ngOnInit(): void {
  }

  browserBackButtonBlocking() {
    history.pushState(null, null, location.href);
    history.back();
    history.forward();
    window.onpopstate = function () {
      history.go(1);
    };
  }

}
